import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import { connect } from 'react-redux';
import Carousel from 'nuka-carousel';

import Page from '../components/Page';
import Modal from '../components/Modal';
import { translations } from '../i18n/translations';

import slider_1 from '../images/slider-1.jpg';
import slider_2 from '../images/slider-2.jpg';
import slider_3 from '../images/slider-3.jpg';

import icon_calculator from '../images/icon-calculator.png';
import icon_checked from '../images/icon-checked.png';
import icon_credit_card from '../images/icon-credit-card.png';
import icon_shield from '../images/icon-shield.png';

import logo_tira from '../images/logos/tira-logo.png';
import logo_iit from '../images/logos/iit-logo.png';
import logo_tra from '../images/logos/tra-logo.png';
import logo_tiba from '../images/logos/tiba-logo.png';
import logo_ati from '../images/logos/ati-logo.png';

import logo_sumatra from '../images/logos/sumatra-logo.png';
import logo_taa from '../images/logos/taa-logo.png';
import logo_tasaa from '../images/logos/tasaa-logo.png';
import logo_tpa from '../images/logos/tpa-logo.png';

import introVideo from '../videos/intro-video.mp4';

class Landing extends Component {
  playVideo = e => {
    this.refs.introVideo.play();
    this.refs.introVideo.volume = 0.2;
  };

  pauseVideo = e => {
    this.refs.introVideo.pause();
  };

  render() {
    return (
      <Page
        pageTitle={translations.buyMCI}
        noPageHeader={true}
        isWideScreen={true}
      >
        <div className="banner-intro clearfix">
          <div className="container card">
            <div className="row">
              <div className="col-sm-6 intro-text">
                <h3 style={{ margin: '1em 0' }}>{translations.mci_portal}</h3>
                <div className="clearfix">
                  <blockquote>
                  Section 133 (3) of the Insurance Act No. 10 of 2009 as amended by Section
                    42 of the Written Laws (Miscellaneous Amendments) Act, 2017 require that ground, marine and air cargo insurance covers for Tanzania imports be effected by a Tanzanian insurer.
                    <br />
                    <br />
                  </blockquote>
                </div>

                <h4 style={{ margin: '1em 0' }}>{translations.buyMCI}</h4>
                <p>
                  <NavLink to="/quote" className="btn btn-success">
                    <span className="glyphicon glyphicon-credit-card" />
                    &nbsp;{translations.buyNow}
                  </NavLink>
                  <NavLink to="/quote" className="btn btn-warning">
                    <span className="glyphicon glyphicon-bookmark" />
                    &nbsp;{translations.get_a_quote}
                  </NavLink>

                  <button
                    className="btn btn-primary"
                    data-toggle="modal"
                    data-target=".video-modal"
                    onClick={this.playVideo}
                  >
                    <i className="icon ion-play" /> &nbsp; Watch Video
                  </button>
                </p>
              </div>
              <div className="col-sm-6">
                <Carousel autoplay={true} wrapAround={true}>
                  <img src={slider_1} className="img-responsive" alt="" />
                  <img src={slider_2} className="img-responsive" alt="" />
                  <img src={slider_3} className="img-responsive" alt="" />
                </Carousel>
              </div>

              <Modal
                className="video-modal"
                closable={true}
                onCloseFn={this.pauseVideo}
              >
                <video
                  src={introVideo}
                  ref="introVideo"
                  id="intro-video"
                  controls
                />
              </Modal>
            </div>
          </div>
        </div>

        <div className="container card partner-logos">
          <h2>Partners</h2>

          <a href="http://tira.go.tz" target="_blank" rel="noopener noreferrer">
            <img src={logo_tira} alt="TIRA" className="img-responsive" />
          </a>

          <a href="http://iit.co.tz/" target="_blank" rel="noopener noreferrer">
            <img src={logo_iit} alt="IIT" className="img-responsive" />
          </a>

          <a
            href="https://www.tra.go.tz/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={logo_tra} alt="TRA" className="img-responsive" />
          </a>

          <a
            href="http://tiba.co.tz/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={logo_tiba} alt="TIBA" className="img-responsive" />
          </a>

          <a href="http://ati.co.tz/" target="_blank" rel="noopener noreferrer">
            <img src={logo_ati} alt="ATI" className="img-responsive" />
          </a>

          <a
            href="http://www.sumatra.go.tz/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={logo_sumatra} alt="SUMATRA" className="img-responsive" />
          </a>

          <a
            href="http://www.taa.go.tz/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={logo_taa} alt="TAA" className="img-responsive" />
          </a>

          <a
            href="https://twitter.com/tasaatz"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={logo_tasaa} alt="TASAA" className="img-responsive" />
          </a>

          <a
            href="http://www.tanzaniaports.com/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={logo_tpa} alt="TPA" className="img-responsive" />
          </a>
        </div>

        <div className="clearfix">
          <div
            className="container home-icons card"
            style={{ padding: '2em 1em' }}
          >
            <div className="col-sm-3 text-right">
              <h2>{translations.itsEasy}</h2>
            </div>
            <div className="col-sm-2">
              <img src={icon_calculator} className="img-responsive" alt="" />
              <span>{translations.get_a_quote}</span>
            </div>
            <div className="col-sm-2">
              <img src={icon_checked} className="img-responsive" alt="" />
              <span>{translations.selectInsurer}</span>
            </div>
            <div className="col-sm-2">
              <img src={icon_credit_card} className="img-responsive" alt="" />
              <span>{translations.payOnline}</span>
            </div>
            <div className="col-sm-2">
              <img src={icon_shield} className="img-responsive" alt="" />
              <span>{translations.getCover}</span>
            </div>
          </div>
        </div>

        <div className="container card">
          <div className="row section-features">
            <div className="col-sm-6">
              <h3>Instant Quotes</h3>
              <p>
                Get a quote in 3 simple steps: SELECT the country of origin;
                SELECT the Type of Goods; ADD the amount for Cost and Freight;
                and VIEW Quotes from different insurers.
              </p>
            </div>
            <div className="col-sm-6">
              <h3>Realtime Data &amp; Analytics</h3>
              <p>
                Harness the power of Big Data; get economic, trade and financial
                insights
              </p>
            </div>
            <div className="col-sm-6">
              <h3>Pay Online</h3>
              <p>
                The Tanzania Imports Insurance Portal provides different online
                payment methods, giving you many convenient options to pay for
                your Marine Cargo Insurance cover.
              </p>
            </div>
            <div className="col-sm-6">
              <h3>Open Cover</h3>
              <p>
                Get MCI covers for both Cash-and-Carry clients as well as
                On-Account clients who enjoy credit facilities. The Tanzania
                Imports Insurance Portal enables you to track credit limits to
                avoid unarranged exposure.
              </p>
            </div>
            <div className="col-sm-6">
              <h3>Reporting</h3>
              <p>
                View and Download a comprehensive set of Reports of your
                transactions on a daily, weekly, monthly or periodic basis.
              </p>
            </div>
            <div className="col-sm-6">
              <h3>Claims Management</h3>
              <p>
                TIRA is committed to ensuring that valid Claims are paid on
                time. The process starts on this Tanzania Imports Insurance
                Portal. All documentation required to start your Claim is
                already available to your Insurer on the Platform.
              </p>
            </div>
          </div>
        </div>
      </Page>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  user: state.user
});

export default connect(mapStateToProps)(Landing);



// WEBPACK FOOTER //
// ./src/pages/Landing.js